<ng-container *ngIf="data">
  <canvas
    *ngIf="data.box?.width && item.resolution?.width"
    class="croppedDetection"
    [id]="item.id"
    width="100%"
    height="100%"
    (click)="goToCamera(item, data)"
    (mouseover)="mouseHover(item)"
    (mouseout)="mouseOut(item)"
  ></canvas>
  <img
    width="100%"
    height="100%"
    [src]="item.detectionsImageUrl"
    *ngIf="!data.box?.width || !item.resolution?.width"
    (click)="goToCamera(item, data)"
  />
  <div class="vehicle-plate-container">
    <sn-icon size="sm">schedule</sn-icon>
    <span>{{ creationDate | fsFormatDate : 'medium' }}</span>
    <ng-container
      *ngIf="data.metadata.vehicleLicensePlate && data.metadata.vehicleLicensePlate[0]?.plate[0]"
    >
      {{ data.metadata.vehicleLicensePlate[0]?.plate[0]?.label }} -
      {{ data.metadata.vehicleLicensePlate[0]?.state[0]?.label }}
    </ng-container>
    <button mat-icon-button [matMenuTriggerFor]="menu" (click)="$event.stopPropagation()">
      <sn-icon>more_vert</sn-icon>
    </button>
    <mat-menu #menu="matMenu">
      <button mat-menu-item (click)="sendToVault(item.detectionsImageUrl)">{{ 'common.addToVault' | t }}</button>
      <button mat-menu-item (click)="selectChannel(item)">{{ 'common.shareInChat' | t }}</button>
      <button mat-menu-item (click)="goToCameraPursuit(item)" *ngIf="allowGoTo">
        {{ 'common.goToCamera' | t }}
      </button>
      <button mat-menu-item (click)="setViewClip(item, data)">{{ 'map.drawing.searchResults.ellipsesMenu.viewClip' | t }}</button>
      <button mat-menu-item (click)="viewDetectionDetails()">{{ 'map.drawing.searchResults.ellipsesMenu.viewDetectionDetails' | t }}</button>
      <button
        *ngIf="!reported() || reporting()"
        mat-menu-item
        [matTooltip]="'map.drawing.searchResults.ellipsesMenu.reportAsIncorrect' | t"
        (click)="incorrectSentryResult(item, data)"
      >
        {{ 'common.reportDetection' | t }}
      </button>
    </mat-menu>
  </div>

  <div class="card-pag" *ngIf="matches.length > 1">
    <button mat-button (click)="preview()" [disabled]="index === 0">
      <sn-icon>navigate_before</sn-icon>{{ 'common.previous' | t }}
    </button>
    <button mat-button (click)="next()" [disabled]="index === matches.length - 1">
      {{ 'common.next' | t }} <sn-icon>navigate_next</sn-icon>
    </button>
  </div>
</ng-container>
